// Ticket Show functionality - Auto scroll messages to bottom

(function() {
  'use strict';

  function scrollTicketMessages() {
    const messagesContainer = document.getElementById('ticket-messages');
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }

  // Auto scroll on navigation
  function initTicketScroll() {
    setTimeout(scrollTicketMessages, 100);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTicketScroll);
  } else {
    initTicketScroll();
  }

  // Re-initialize on Livewire navigation
  document.addEventListener('livewire:navigated', initTicketScroll);

  // Listen for ticket-updated event
  if (typeof window !== 'undefined') {
    // Wait for Livewire to be available
    function setupTicketListener() {
      if (typeof Livewire !== 'undefined') {
        Livewire.on('ticket-updated', function() {
          setTimeout(scrollTicketMessages, 100);
        });
      } else {
        // Retry after a short delay
        setTimeout(setupTicketListener, 100);
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupTicketListener);
    } else {
      setupTicketListener();
    }
  }
})();

